// import Quill from 'quill';
//
// const icons = Quill.import('ui/icons');
// Object.assign(icons, {
//     bold: '<b title="Negrito">N</b>',
//     italic: '<i title="Itálico">I</i>',
//     underline: '<u title="Sublinhado">S</u>',
//     link: '<span title="Link">🔗</span>',
//     clean: '<span title="Limpar Formatação">🧹</span>',
// });
//
// const BaseTooltip = Quill.import('ui/tooltip');
//
// class CustomLinkTooltip extends BaseTooltip {
//     constructor(quill: any, boundsContainer?: any) {
//         super(quill, boundsContainer);
//
//         (this as any)['root'].innerHTML = `
//       <a class="ql-preview" target="_blank" href="about:blank">Visitar URL:</a>
//       <input type="text" class="ql-link-input" placeholder="Insira o link...">
//       <button type="button" class="ql-action">Aplicar</button>
//       <button type="button" class="ql-remove">Remover</button>
//     `;
//
//         (this as any)['root'].querySelector('.ql-preview')?.addEventListener('click', (e: Event) => {
//             e.preventDefault();
//             const href = ((this as any)['root'].querySelector('.ql-preview') as HTMLAnchorElement).href;
//             window.open(href, '_blank');
//         });
//
//         (this as any)['root'].querySelector('.ql-action')?.addEventListener('click', () => this['save']());
//         (this as any)['root'].querySelector('.ql-remove')?.addEventListener('click', () => this['remove']());
//     }
// }
//
// Quill.register('modules/tooltip', CustomLinkTooltip, true);
